import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

/**
 * Single-series bar breakdown by a dimension (Service Disruption per unit,
 * Requirement Defect Ratio per unit, MTTR per unit).
 */
function SimpleBarChart({ data, dimensionKey, valueKey, color = 'var(--cmp-primary)', height = 200, valueSuffix = '', colorByIndex }) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 50 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey={dimensionKey} tick={{ fontSize: 11 }} angle={-30} textAnchor="end" interval={0} />
        <YAxis tick={{ fontSize: 11 }} />
        <Tooltip formatter={(v) => `${v}${valueSuffix}`} />
        <Bar dataKey={valueKey} fill={color} radius={[3, 3, 0, 0]}>
          {colorByIndex && data.map((_, i) => <Cell key={i} fill={colorByIndex(i)} />)}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default SimpleBarChart;
